export enum ENUM__number_range {
  LOW_TO_HIGH = 'LOW_TO_HIGH',
  HIGH_TO_LOW = 'HIGH_TO_LOW',
  ANY = 'ANY',
}
